import { Users, Activity, Target, BarChart } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface StatsOverviewProps {
  stats: {
    totalUsers: number;
    activeUsers: number;
    totalSessions: number;
    todaySessions: number;
    totalShots: number;
    avgShotQuality: number;
  };
  isAdmin: boolean;
}

export function StatsOverview({ stats, isAdmin }: StatsOverviewProps) {
  const statItems = [
    {
      title: isAdmin ? 'Total Users' : 'Team Members',
      value: stats.totalUsers,
      description: `${stats.activeUsers} active`,
      icon: Users,
      trend: '+12% from last month'
    },
    {
      title: 'Sessions',
      value: stats.totalSessions,
      description: `${stats.todaySessions} today`,
      icon: Activity,
      trend: '+8% from last month'
    },
    {
      title: 'Total Shots',
      value: stats.totalShots.toLocaleString(),
      description: 'All time',
      icon: Target,
      trend: '+23% from last month'
    },
    {
      title: 'Avg Quality',
      value: `${stats.avgShotQuality}/10`,
      description: 'Overall rating',
      icon: BarChart,
      trend: '+0.3 from last month'
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {statItems.map((item, index) => (
        <Card key={index}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{item.title}</CardTitle>
            <item.icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{item.value}</div>
            <p className="text-xs text-muted-foreground">
              {item.description}
            </p>
            <p className="text-xs text-green-600 mt-1">
              {item.trend}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}